import { twMerge } from 'tailwind-merge';
import type { SelectedFile } from '@witmetrics/utils';
import { formatFileSize } from '@witmetrics/utils/strings';
import { useNewCase } from '@/providers/NewCaseProvider';
import Card from '@/components/Card';
import Title from '@/components/Title';
import IconButton from '@/components/IconButton';
import { CloseIcon } from '@/icons';
import ItemImage from './ItemImage';
import { classes, styles } from './utils';

export type FileItemProps = {
  className?: string;
  selectedFile: SelectedFile;
  onPreview: (uuid: string) => void;
};

export default function FileItem({
  className,
  selectedFile,
  onPreview,
}: FileItemProps) {
  const { onRemoveFiles } = useNewCase();

  return (
    <Card sx={styles.card} className={twMerge(classes.card, className)}>
      <button
        className={classes.content}
        type="button"
        onClick={() => onPreview(selectedFile.uuid)}>
        <ItemImage selectedFile={selectedFile} />
        <div className={classes.details}>
          <Title className={classes.title} size="xs">
            {selectedFile.file.name}
          </Title>
          <div className={classes.subtitle}>
            {formatFileSize(selectedFile.file.size)}
          </div>
        </div>
      </button>
      <IconButton onClick={() => onRemoveFiles([selectedFile.uuid])}>
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    </Card>
  );
}
